<template>
  <v-card class="mt-3 pa-2">
    <h5 class="headline">
      <template v-if="group.fieldName == 'startDate'"
        >Day {{ indexNo + 1 }}: {{ group.label | formatDate }}</template
      >
      <template v-else>{{ groupLabel }}</template>
    </h5>
    <itinerary-items-list-table
      :headers="headers"
      :visible-columns="visibleColumns"
      :items="group.items"
      :currency-code="currencyCode"
      :basic-comps="basicComps"
      @action="onItemsListAction"
      @supplier-edit="$emit('supplier-edit', $event)"
      :flagsEditDisabledFn="flagsEditDisabledFn"
      @showMoveDays="onShowMoveDays"
      @onRecalculate="onRecalculate"
      @reorderSelectedServices="onReorderSelectedServices"
      @customPriceToggle="onCustomPriceToggle"
      @zeroSelectedServices="onZeroSelectedServices"
      @showPaxUpdater="onShowPaxUpdater"
      @removeSelectedServices="onRemoveSelectedServices"
      @showUpdateStatus="onShowUpdateStatus"
      @showItiComps="onShowItiComps"
      @showRemarksEdit="onShowRemarksEdit"
      @showPriceAdjuster="onShowPriceAdjuster"
      @orderNoChange="onOrderNoChange"
      @refreshPrices="onRefreshPrices"
      @timeChange="onTimeChange"
      @isIncludedChange="onIsIncludedChange"
      @isOptionalChange="onIsOptionalChange"
      :search="search"
    ></itinerary-items-list-table>
    <v-card-actions>
      <v-layout justify-center>
        <v-btn
          text
          color="primary"
          @click="onRatesSearch"
          v-if="$store.getters.hasAccessTo('third_party:visible')"
        >
          <v-icon left>mdi-magnify</v-icon>Rates Search
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="onAddItem"
          v-if="!$store.getters.hasAccessTo('itineraries:hide_quick_access')"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>Quick Add
        </v-btn>
        <v-btn text color="primary" @click="onAddAdhoc">
          <v-icon left>mdi-plus-circle-outline</v-icon>Add Service
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="onAddTemplate"
          v-if="!$store.getters.hasAccessTo('itineraries:hide_add_template')"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>Add Template
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="onAddCharge"
          v-if="!$store.getters.hasAccessTo('itineraries:hide_add_charge')"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>Add Charge
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="onAddFromAllocations"
          v-if="!$store.getters.hasAccessTo('itineraries:hide_add_allocation')"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>Add From Allocations
        </v-btn>
      </v-layout>
    </v-card-actions>
    <div v-if="debug">
      <p>{{ headers2show }}</p>
    </div>
  </v-card>
</template>
<script>
import ItineraryItemsListTable from "../../shared/ItineraryItemsListTable";
const moment = require("moment");
export default {
  name: "ItineraryBuilderItemsGroup",

  props: {
    indexNo: {
      type: Number,
      default: () => 0,
    },
    group: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    currencyCode: {
      type: String,
      default: () => "",
    },
    flagsEditDisabledFn: {
      type: Function,
      default: (item) => false,
    },
    basicComps: {
      type: Boolean,
      default: () => true,
    },
    search: {
      type: String,
      default: "",
    },
  },

  components: {
    ItineraryItemsListTable,
  },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    groupLabel() {
      return this.group
        ? this.group.label == "MANDATORY_CHARGES"
          ? "ITINERARY CHARGES"
          : this.group.label
        : "";
    },
  },

  methods: {
    onShowPriceAdjuster(payload) {
      this.$emit("showPriceAdjuster", payload);
    },
    onRecalculate() {
      console.log("group onRecalculate");
      this.$emit("onRecalculate");
    },
    onShowMoveDays(payload) {
      this.$emit("showMoveDays", payload);
    },
    onReorderSelectedServices(payload) {
      this.$emit("reorderSelectedServices", payload);
    },
    onCustomPriceToggle(payload) {
      this.$emit("customPriceToggle", payload);
    },
    onZeroSelectedServices(payload) {
      this.$emit("zeroSelectedServices", payload);
    },
    onShowPaxUpdater(payload) {
      this.$emit("showPaxUpdater", payload);
    },
    onRemoveSelectedServices(payload) {
      this.$emit("removeSelectedServices", payload);
    },
    onShowUpdateStatus(payload) {
      this.$emit("showUpdateStatus", payload);
    },
    onShowItiComps(payload) {
      this.$emit("showItiComps", payload);
    },
    onShowRemarksEdit(payload) {
      this.$emit("showRemarksEdit", payload);
    },
    onItemsListAction(payload) {
      this.$emit("action", payload);
    },
    onRatesSearch() {
      this.$emit("action", { action: "show-rs", payload: this.group });
    },
    onAddItem() {
      this.$emit("action", { action: "addItem", payload: this.group });
    },
    onAddAdhoc() {
      this.$emit("action", { action: "addAdhoc", payload: this.group });
    },
    onAddTemplate() {
      this.$emit("action", { action: "addTemplate", payload: this.group });
    },
    onAddCharge() {
      this.$emit("action", { action: "addCharge", payload: this.group });
    },
    onAddFromAllocations() {
      this.$emit("action", {
        action: "addFromAllocations",
        payload: this.group,
      });
    },
    onOrderNoChange(payload) {
      this.$emit("orderNoChange", payload);
    },
    onTimeChange(payload) {
      this.$emit("timeChange", payload);
    },
    onRefreshPrices(payload) {
      this.$emit("refreshPrices", payload);
    },
    onIsIncludedChange(payload) {
      this.$emit("isIncludedChange", payload);
    },
    onIsOptionalChange(payload) {
      this.$emit("isOptionalChange", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemsGroup.vue